const TICKER_ITEMS = [
  "Advaith vs Life",
  "Match Day 01",
  "90 minutes of unfiltered storytelling",
  "The game is still being played",
  "Kick-off imminent",
];

export default function Marquee() {
  const row = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-[#0A0A0A] border-b-4 border-black overflow-hidden py-3.5 sm:py-4"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-display uppercase text-lg sm:text-2xl tracking-wide text-[#84E116] whitespace-nowrap"
              >
                <span className="px-6 sm:px-8">{item}</span>
                <svg viewBox="0 0 24 24" className="w-4 h-4 sm:w-5 sm:h-5 shrink-0" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" fill="none" stroke="#84E116" strokeWidth="2" />
                  <path d="M12 5 L16.5 8.5 L15 13.5 L9 13.5 L7.5 8.5 Z" fill="#84E116" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
